import { com } from '@eidu/web'
import entityApiUrl from '../baseUrl'
import permissionPolicyDTO, { PermissionPolicyDTO } from '../../../../domain/permission/PermissionPolicyDTO'
import fetchAuthorized from '../../authorization/fetchAuthorized'
import serializeToJsonString = com.eidu.sharedlib.entity.util.serializeToJsonString
import PermissionPolicyId = com.eidu.sharedlib.entity.permission.PermissionPolicyId
import Permission = com.eidu.sharedlib.entity.permission.Permission
import PermissionPolicy = com.eidu.sharedlib.entity.permission.PermissionPolicy
import UpdatePermissionPolicyRequest = com.eidu.sharedlib.entity.api.permissions.UpdatePermissionPolicyRequest
import NonEmptySet = com.quickbirdstudios.nonEmptyCollection.set.NonEmptySet

export type UpdatePermissionPolicyParameters = {
  id: PermissionPolicyId
  name: string
  permissions: readonly Permission[]
}

const updatePermissionPolicy = async ({
  id,
  name,
  permissions,
}: UpdatePermissionPolicyParameters): Promise<PermissionPolicyDTO> => {
  return fetchAuthorized(
    (authContext) =>
      `${entityApiUrl}/organizations/${authContext.organizationId}/permissions/policies/${id.toString()}`,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: serializeToJsonString(
        new UpdatePermissionPolicyRequest(new PermissionPolicy(name, NonEmptySet.fromArray([...permissions])))
      ),
      method: 'PUT',
    }
  ).then(async (response) => {
    if (response.status !== 200)
      throw Error(`Unexpected response code ${response.status} from updatePermissionPolicy endpoint`)
    return permissionPolicyDTO((await response.json()).document)
  })
}

export default updatePermissionPolicy
